import React, { useEffect, useState } from 'react';
import '../ProductStatusFilter.css';
import { Button } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';

function SupplyOrderFilter({ handleFilters }) {
    const { register, handleSubmit } = useForm();
    const history = useHistory();

    const handleChangedFilter = (data) => {
        handleFilters(data);
    }

    return (
        <>
            <form onChange={handleSubmit(handleChangedFilter)}>
                <div className="allProducts__productStatusFilter">
                    <div className={`allProducts__productStatusContent allProducts__flexContent`}>
                        <Button 
                            variant="contained" 
                            className={`employerIndex__createPostBtn employerIndex__createProduct`}
                            onClick={() => history.push('/supply/create-order')}>Create Order</Button>
                    </div>
                </div>
            </form>
        </>
    )
}

export default SupplyOrderFilter
